import { render, staticRenderFns } from "./SingleAwardsResults.vue?vue&type=template&id=f383cc4e&scoped=true"
import script from "./SingleAwardsResults.vue?vue&type=script&lang=js"
export * from "./SingleAwardsResults.vue?vue&type=script&lang=js"
import style0 from "./SingleAwardsResults.vue?vue&type=style&index=0&id=f383cc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f383cc4e",
  null
  
)

/* custom blocks */
import block0 from "./SingleAwardsResults.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports